// components/PermissionWrapper.js
import React, { useContext } from "react";
import { LoginContext } from "./LoginContext";
import ErrorPage from "../pages/ErrorPage";

const ProtectedComponent = ({ children, module, action, roles }) => {
  const { hasPermission, user } = useContext(LoginContext);

  // Role-based gate: when a `roles` array is passed, access is decided by the
  // user's role instead of a module/action permission (e.g. admin/CRO-only pages).
  if (Array.isArray(roles) && roles.length) {
    if (user === undefined || user === null) {
      // Still loading the user.
      return <div>Loading Permissions...</div>;
    }
    const role = String(user?.role || "").toLowerCase();
    const allowed = roles.map((r) => String(r).toLowerCase()).includes(role);
    return allowed ? children : <ErrorPage />;
  }

  const permissionResult = hasPermission(module, action);

  if (permissionResult === null) {
    // Still loading
    return <div>Loading Permissions...</div>;
  }

  if (!permissionResult) {
    return <ErrorPage />;
  }

  return children;
};


export default ProtectedComponent;